import { TaskType } from "__graphql__/types";
import { PageName } from "analytics/events";
import { getInventoryPeriodKey } from "flows/Inventory/shared/utils/inventoryChecks";

import { BaseChecksList } from "./BaseChecksList";

export function EoyChecksList() {
  const checksTitle = getInventoryPeriodKey();

  return (
    <BaseChecksList
      taskType={TaskType.eoy_inventory_check}
      pageOrigin={PageName.INVENTORY_EOY_CHECK_LIST_PAGE}
      title={checksTitle}
    />
  );
}
